import Theme from "@/components/Theme";
import Hero from "@/organisms/Hero";
import FeatureSectionTwocol from "@/organisms/FeatureSectionTwocol";
import BadgeSection from "@/components/organisms/BadgeSection";
import Slider from "@/components/organisms/Slider";
import RegistrationForm from "@/components/molecules/RegistrationForm";
import Discover from "@/organisms/Discover";
import ProudMember from "@/components/organisms/ProudMember";
import EbookSection from "@/components/organisms/EbookSection";
import Trustpilot from "@/organisms/Trustpilot";
import Faq from "@/components/organisms/FaqSection";
import * as roofing from "@/data/industries/roofing";
import * as appliancerepair from "@/data/industries/appliance-repair";
import * as construction from "@/data/industries/construction";
import * as hvac from "@/data/industries/hvac-answering-service";
import * as handyman from "@/data/industries/handyman";
import * as propertymaintenance from "@/data/industries/property-maintenance";
import * as solar from "@/data/industries/solar";
import * as painting from "@/data/industries/painting";
import * as locksmith from "@/data/industries/locksmith";
import * as garagedoor from "@/data/industries/garage-door";
import * as pestcontrol from "@/data/industries/pest-control";
import * as flooring from "@/data/industries/flooring";
import * as restorationansweringservice from "@/data/industries/restoration-answering-service";
import * as homeservices from "@/data/industries/home-services";
export async function getStaticPaths() {
  const paths = [
    { params: { industryPages: "roofing" } },
    { params: { industryPages: "appliance-repair" } },
    { params: { industryPages: "construction" } },
    { params: { industryPages: "hvac-answering-service" } },
    { params: { industryPages: "solar" } },
    { params: { industryPages: "handyman" } },
    { params: { industryPages: "property-maintenance" } },
    { params: { industryPages: "painting" } },
    { params: { industryPages: "locksmith" } },
    { params: { industryPages: "garage-door" } },
    { params: { industryPages: "pest-control" } },
    { params: { industryPages: "flooring" } },
    { params: { industryPages: "restoration-answering-service" } },
    { params: { industryPages: "home-services" } },
  ];
  return {
    paths: paths,
    fallback: false,
  };
}
export async function getStaticProps({ params: { industryPages } }) {
  let data = {};
  const contentMap = {
    roofing,
    "appliance-repair": appliancerepair,
    construction,
    "hvac-answering-service": hvac,
    solar,
    handyman,
    "property-maintenance": propertymaintenance,
    painting,
    locksmith,
    "garage-door": garagedoor,
    "pest-control": pestcontrol,
    flooring,
    "restoration-answering-service": restorationansweringservice,
    "home-services": homeservices,
  };
  if (!industryPages) {
    return {
      notFound: true,
    };
  }
  data.marketing = { ...contentMap[industryPages]["marketing"] };
  data.content = { ...contentMap[industryPages]["content"] };
  return {
    props: {
      data,
      pagename: industryPages,
    },
  };
}
export default function IndustryPages({ data, pagename }) {
  const seoData = data?.marketing;
  const pagedata = data?.content;

  const hero = pagedata?.hasOwnProperty("hero") && (
    <Hero
      heroTitle={pagedata.hero.title}
      heroContent={pagedata.hero.content}
      heroImgData={pagedata.hero.heroImgData}
      hasPricingCta={pagedata.hero.hasPricingCta}
      hasTrustpilot={pagedata.hero.hasTrustpilot}
    />
  );

  return (
    <Theme mainClassName="main" hero={hero} seo={seoData}>
      {pagedata?.hasOwnProperty("featureSectionTwocol1") && (
        <FeatureSectionTwocol
          title={pagedata.featureSectionTwocol1.title}
          image={pagedata.featureSectionTwocol1.image}
          bgColor={pagedata.featureSectionTwocol1.bgColor}
          content={pagedata.featureSectionTwocol1.content}
          isImageOnLeft={pagedata.featureSectionTwocol1.isImageOnLeft}
          hasTitleDot={pagedata.featureSectionTwocol1.hasTitleDot}
          hasPlayBtn={pagedata.featureSectionTwocol1.hasPlayBtn}
          videoSrc={pagedata.featureSectionTwocol1.videoSrc}
          hasVideoThumbnail={pagedata.featureSectionTwocol1.hasVideoThumbnail}
        />
      )}
      {pagename !== "hvac-answering-service" &&
        pagedata?.hasOwnProperty("featureSectionTwocol2") && (
          <FeatureSectionTwocol
            image={pagedata.featureSectionTwocol2.image}
            bgColor={pagedata.featureSectionTwocol2.bgColor}
            isImageOnLeft={pagedata.featureSectionTwocol2.isImageOnLeft}
            hasTitleDot={pagedata.featureSectionTwocol2.hasTitleDot}
            hasRegisterForm={pagedata.featureSectionTwocol2.hasRegisterForm}
            formTitle={pagedata.featureSectionTwocol2.formTitle}
            hasBusinessName={pagedata.featureSectionTwocol2.hasBusinessName}
            formBgColor={pagedata.featureSectionTwocol2.formBgColor}
            formUniqueName={`page-${pagename}-default`}
          />
        )}
      {pagedata?.hasOwnProperty("slider") && (
        <Slider
          data={pagedata.slider.data}
          variant={pagedata.slider.variant}
          title={pagedata.slider.title}
          subTitle={pagedata.slider.subTitle}
        />
      )}

      {pagename === "restoration-answering-service" &&
        pagedata?.hasOwnProperty("badgeSection") && (
          <BadgeSection
            label={pagedata.badgeSection.label}
            title={pagedata.badgeSection.title}
            bgColor={pagedata.badgeSection.bgColor}
            image={pagedata.badgeSection.image}
            hasAestheticBg={pagedata.badgeSection.hasAestheticBg}
          />
        )}
      {pagename === "hvac-answering-service" &&
        pagedata?.hasOwnProperty("proudMember") && (
          <ProudMember
            content={pagedata.proudMember.content}
            image={pagedata.proudMember.image}
            href={pagedata.proudMember.href}
          />
        )}
      {pagename === "restoration-answering-service" &&
        pagedata?.hasOwnProperty("ebookSection") && (
          <EbookSection
            isImageOnLeft={pagedata.ebookSection.isImageOnLeft}
            title={pagedata.ebookSection.title}
            label={pagedata.ebookSection.label}
            image={pagedata.ebookSection.image}
            href={pagedata.ebookSection.href}
          />
        )}
      {pagedata?.hasOwnProperty("featureSectionTwocol3") && (
        <FeatureSectionTwocol
          title={pagedata.featureSectionTwocol3.title}
          image={pagedata.featureSectionTwocol3.image}
          bgColor={pagedata.featureSectionTwocol3.bgColor}
          content={pagedata.featureSectionTwocol3.content}
          isImageOnLeft={pagedata.featureSectionTwocol3.isImageOnLeft}
          hasTitleDot={pagedata.featureSectionTwocol3.hasTitleDot}
          ctaData={pagedata.featureSectionTwocol3.ctaData}
        />
      )}
      {pagename === "hvac-answering-service" &&
        pagedata?.hasOwnProperty("ebookSection") && (
          <EbookSection
            isImageOnLeft={pagedata.ebookSection.isImageOnLeft}
            title={pagedata.ebookSection.title}
            label={pagedata.ebookSection.label}
            image={pagedata.ebookSection.image}
            href={pagedata.ebookSection.href}
          />
        )}
      {pagedata?.hasOwnProperty("featureSectionTwocol4") && (
        <FeatureSectionTwocol
          title={pagedata.featureSectionTwocol4.title}
          image={pagedata.featureSectionTwocol4.image}
          bgColor={pagedata.featureSectionTwocol4.bgColor}
          content={pagedata.featureSectionTwocol4.content}
          isImageOnLeft={pagedata.featureSectionTwocol4.isImageOnLeft}
          hasTitleDot={pagedata.featureSectionTwocol4.hasTitleDot}
          ctaData={pagedata.featureSectionTwocol4.ctaData}
        />
      )}
      {pagedata?.hasOwnProperty("trustPilot") && (
        <Trustpilot
          title={pagedata.trustPilot.title}
          variant={pagedata.trustPilot.variant}
          className={pagedata.trustPilot.className}
        />
      )}
      {pagedata?.hasOwnProperty("miniRegister") && (
        <RegistrationForm
          title={pagedata.miniRegister.title}
          content={pagedata.miniRegister.content}
          hasBusinessNameField={false}
          variant="mini"
          formUniqueName={`page-${pagename}-mini`}
        ></RegistrationForm>
      )}
      {pagedata?.hasOwnProperty("faq") && <Faq data={pagedata.faq.faqData} />}
      {pagedata?.hasOwnProperty("discover") && (
        <Discover
          bgColor={pagedata.discover.bgColor}
          title={pagedata.discover.title}
          color={pagedata.discover.color}
          cta={pagedata.discover.cta}
          href={pagedata.discover.href}
        />
      )}
    </Theme>
  );
}
